module.exports = __webpack_public_path__ + "img/416-43a58c.png";